import content from "app-content";
import {
  IN_STOCK,
  LOW_IN_STOCK,
  OUT_OF_STOCK,
  COLOUR_OUT_OF_STOCK,
  SIZE_OUT_OF_STOCK,
  COLOUR_OR_SIZE_OUT_OF_STOCK,
  RESTOCKING_SOON
} from "./stockConstants";

const stockStatusMap = {
  [IN_STOCK]: null,
  [OUT_OF_STOCK]: content.saved_items_accessibility_out_of_stock,
  [LOW_IN_STOCK]: content.saved_items_accessibility_low_in_stock,
  [COLOUR_OUT_OF_STOCK]: content.saved_items_accessibility_colour_out_of_stock,
  [SIZE_OUT_OF_STOCK]: content.saved_items_accessibility_size_out_of_stock,
  [COLOUR_OR_SIZE_OUT_OF_STOCK]:
    content.saved_items_accessibility_size_colour_out_of_stock,
  [RESTOCKING_SOON]: content.back_in_stock_soon_label
};

export default stockStatus => stockStatusMap[stockStatus];
